import React from 'react'
import Celulas from './Celulas'

const CelulasWrapper = () => {
  return <Celulas />
}

export default CelulasWrapper
